const SHARED_INFLIGHT_KEY = '__cxReviewsRequestInFlight';
const moduleInflightRequests = new Map();

const getInflightRequests = () => {
    const scope = typeof globalThis !== 'undefined'
        ? globalThis
        : (typeof window !== 'undefined' ? window : null);

    if (!scope) {
        return moduleInflightRequests;
    }

    if (!scope[SHARED_INFLIGHT_KEY]) {
        scope[SHARED_INFLIGHT_KEY] = new Map();
    }

    return scope[SHARED_INFLIGHT_KEY];
};

const getAbortError = () => {
    try {
        return new DOMException('Aborted', 'AbortError');
    } catch (error) {
        const abortError = new Error('Aborted');
        abortError.name = 'AbortError';
        return abortError;
    }
};

const asJsonBody = (value) => {
    if (value === undefined || value === null) {
        return '';
    }

    return typeof value === 'string' ? value : JSON.stringify(value);
};

const withAbortSignal = (promise, signal) => {
    if (!signal) {
        return promise;
    }

    if (signal.aborted) {
        return Promise.reject(getAbortError());
    }

    return Promise.race([
        promise,
        new Promise((_, reject) => {
            signal.addEventListener('abort', () => reject(getAbortError()), {once: true});
        })
    ]);
};

const fetchJson = async (url, requestInit) => {
    const response = await fetch(url, requestInit);
    if (!response.ok) {
        const error = new Error(`Request failed with status ${response.status}`);
        error.status = response.status;
        throw error;
    }

    return response.json();
};

export const fetchJsonSharedInFlight = ({
    url,
    method = 'GET',
    headers,
    body,
    signal
}) => {
    const inflightRequests = getInflightRequests();
    const normalizedMethod = String(method || 'GET').toUpperCase();
    const serializedBody = asJsonBody(body);
    const cacheKey = `${normalizedMethod}::${url}::${serializedBody}`;
    const requestHeaders = headers && Object.keys(headers).length ? headers : undefined;
    const requestInit = {
        method: normalizedMethod,
        headers: requestHeaders
    };

    if (serializedBody) {
        requestInit.body = serializedBody;
    }

    if (!inflightRequests.has(cacheKey)) {
        const promise = fetchJson(url, requestInit)
            .finally(() => {
                inflightRequests.delete(cacheKey);
            });
        inflightRequests.set(cacheKey, promise);
    }

    return withAbortSignal(inflightRequests.get(cacheKey), signal);
};
